import IntroduceIcon from '@/assets/img/introduce.jpg';
import * as S from './style';
const IntroduceOwner = () => (
	<S.IntroduceOwnerContainer>
		<S.OwnerImage>
			<img src={IntroduceIcon} alt="introduce" />
		</S.OwnerImage>
		<S.OwnerContentBox>
			<S.OwnerTitleBox>
				<S.OwnerTitle>존경하는 한국노화학회 회원 여러분,</S.OwnerTitle>
				<S.OwnerDescription>안녕하십니까,</S.OwnerDescription>
				<S.OwnerDescription>2026년 한국노화학회 회장으로 취임하게 된 부산대학교 이재원입니다.</S.OwnerDescription>
				<S.OwnerDescription>
					우리나라는 초고령 사회에 본격적으로 진입하며, 노화 연구의 중요성은 그 어느 때보다 커지고 있습니다.
					<br />
					이러한 시대적 요구 속에서 한국노화학회는 노화 연구를 선도하고, <br />
					건강한 노화를 위한 과학적 근거를 제시하는 중심 학회로서 중요한 역할을 수행해 왔습니다.
				</S.OwnerDescription>
				<S.OwnerDescription>
					지난 한 해 동안 전임 회장단과 회원 여러분의 헌신적인 노력으로 학회는 학문적 내실을 다지고 미래 도약을 위한 소중한 기반을 마련하였습니다. 신임
					회장으로서 저는 그 성과를 바탕으로, 새로운 시각과 책임감을 가지고 학회를 한 단계 더 도약시키고자 합니다.
				</S.OwnerDescription>
				<S.OwnerDescription>2026년 한국노화학회는 다음과 같은 방향을 중심으로 새롭게 나아가겠습니다.</S.OwnerDescription>
				<S.OwnerContentMenuBox>
					<S.OwnerDescription>
						<S.OwnerSubTitle>
							1. 학술 활동의 질적 도약
							<br />
						</S.OwnerSubTitle>
						춘계 및 추계 학술대회를 중심으로 최신 연구 성과와 혁신적인 연구 흐름을 공유하며, 다학제적 노화 연구의 장을 더욱 활성화하겠습니다.
					</S.OwnerDescription>
					<S.OwnerDescription>
						<S.OwnerSubTitle>
							2. 젊은 연구자 양성과 참여 확대
							<br />
						</S.OwnerSubTitle>
						차세대 연구자들이 학회의 주역으로 성장할 수 있도록 연구 지원과 학술 참여 기회를 확대하여, 노화 연구의 지속 가능성을 강화하겠습니다.
					</S.OwnerDescription>
					<S.OwnerDescription>
						<S.OwnerSubTitle>
							3. 국내외 협력 네트워크의 확장
							<br />
						</S.OwnerSubTitle>
						국내외 학회 및 연구 기관과의 협력을 한층 심화하여, 글로벌 노화 연구 환경 속에서 한국노화학회의 위상을 높이겠습니다.
					</S.OwnerDescription>
					<S.OwnerDescription>
						<S.OwnerSubTitle>
							4. 연구 지원 기반의 체계적 강화
							<br />
						</S.OwnerSubTitle>
						노화 연구를 위한 연구비 확보와 지원 체계를 정비하여, 회원 여러분이 안정적인 연구 환경에서 연구에 전념할 수 있도록 노력하겠습니다
					</S.OwnerDescription>
				</S.OwnerContentMenuBox>

				<S.OwnerDescription>
					신임 회장으로서 저는 회원 여러분의 목소리에 귀 기울이며, 열린 소통과 책임 있는 운영을 통해 한국노화학회의 새로운 미래를 함께 만들어가고자 합니다.
					2026년이 우리 학회가 또 한 번 도약하는 의미 있는 해가 되기를 기대합니다.
				</S.OwnerDescription>

				<S.OwnerDescription>
					회원 여러분의 지속적인 관심과 적극적인 참여를 부탁드리며, <br />
					항상 건강과 행복이 함께하시기를 기원합니다.
				</S.OwnerDescription>
				<S.OwnerDescription>감사합니다.</S.OwnerDescription>
			</S.OwnerTitleBox>
			<S.OwnerSign>
				<S.OwnerDescription>2026 년 한국노화학회 회장</S.OwnerDescription>
				<S.OwnerNameBox>
					<S.OwnerName>
						<strong>이 재 원</strong>
						드림
					</S.OwnerName>
				</S.OwnerNameBox>
			</S.OwnerSign>
		</S.OwnerContentBox>
	</S.IntroduceOwnerContainer>
);

export default IntroduceOwner;
